import { useEffect } from "react";
const usePreventScroll = (options = {}) => {
  const {
    isDisabled = false,
    restoreScrollPosition = false,
    preserveScrollPosition = false
  } = options;
  useEffect(() => {
    const { overflow, position, height, width, top, left } = document.body.style;
    const { scrollX, scrollY } = window;
    if (!isDisabled) {
      Object.assign(document.body.style, {
        overflow: "hidden",
        position: "fixed",
        height: "100vh",
        width: "100vw",
        ...{
          top: preserveScrollPosition ? `-${scrollY}px` : "0px",
          left: preserveScrollPosition ? `-${scrollX}px` : "0px"
        }
      });
    }
    return () => {
      Object.assign(document.body.style, {
        overflow,
        position,
        width,
        height,
        top,
        left
      });
      if (restoreScrollPosition) {
        window.scrollTo(scrollX, scrollY);
      }
    };
  }, [isDisabled, preserveScrollPosition, restoreScrollPosition]);
};
var usePreventScroll_default = usePreventScroll;
export {
  usePreventScroll_default as default
};
